import React from 'react';
import ContactsIcon from '@mui/icons-material/Contacts';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import {CardHeader, CardWrapper, ContactItem, Title,} from './styles';
import {useDashboardContext} from "../../../Dashboard";

export default function ContactsModal() {
    const {CONTACTS_DATA, settings: {firm}} = useDashboardContext();
    return (
        <CardWrapper>
            <CardHeader>
                <ContactsIcon color="primary"/>
                <Title>{CONTACTS_DATA.title}</Title>
            </CardHeader>
            {firm.phone && <ContactItem><PhoneIcon/><span>{firm.phone}</span></ContactItem>}
            {firm.email && <ContactItem><EmailIcon/><span>{firm.email}</span></ContactItem>}
            {firm.address && <ContactItem><LocationOnIcon/><span>{firm.address}</span></ContactItem>}
            {firm.workingHours && <ContactItem><AccessTimeIcon/><span>{firm.workingHours}</span></ContactItem>}
        </CardWrapper>
    );
}
